import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Factory, ArrowUpRight, MessageCircle, Printer } from "lucide-react";
import { BRAND, REGIONS } from "@/lib/site";

const Col = ({ title, children }) => (
  <div>
    <p className="eyebrow eyebrow-dark mb-6">{title}</p>
    <div className="space-y-3 text-sm text-slate-300">{children}</div>
  </div>
);

export const Footer = () => (
  <footer id="footer" data-testid="site-footer" className="relative bg-[var(--navy-deep)] text-white overflow-hidden">
    <div className="absolute -right-40 -top-40 h-[560px] w-[560px] rounded-full stripes opacity-40 [mask-image:radial-gradient(circle,black,transparent_70%)]" />
    <div className="container-x relative py-20">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-4">
            <img src={BRAND.logo} alt={BRAND.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-white/10" />
            <div>
              <div className="font-display text-xl font-semibold">{BRAND.short}</div>
              <div className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[var(--mint-light)]">Global Resources LLP</div>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            Manufacturer and exporter of GVT / PGVT glazed vitrified tiles. Crafted in India, directed from New Delhi, delivered across the world.
          </p>
          <p className="mt-6 font-display italic text-lg text-[var(--mint-light)]">{BRAND.tagline}</p>
        </div>

        <div className="lg:col-span-2">
          <Col title="Explore">
            <Link to="/#about" className="block hover:text-white transition-colors">Company Profile</Link>
            <Link to="/collection" className="block hover:text-white transition-colors">Our Collection</Link>
            <Link to="/#global" className="block hover:text-white transition-colors">Across the Globe</Link>
            <Link to="/#catalogues" className="block hover:text-white transition-colors">E-Catalogue</Link>
            <Link to="/#calculator" className="block hover:text-white transition-colors">Tiles Calculator</Link>
            <Link to="/#contact" className="block hover:text-white transition-colors">Contact Us</Link>
          </Col>
        </div>

        <div className="lg:col-span-3">
          <Col title="Locations">
            <div className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-[var(--mint-light)]" /><div><div className="font-semibold text-white">{BRAND.headOffice.label}</div>{BRAND.headOffice.lines.map((l) => <div key={l}>{l}</div>)}</div></div>
            <div className="flex gap-3 pt-2"><Factory size={16} className="mt-0.5 shrink-0 text-[var(--mint-light)]" /><div><div className="font-semibold text-white">{BRAND.factory.label}</div>{BRAND.factory.lines.map((l) => <div key={l}>{l}</div>)}</div></div>
          </Col>
        </div>

        <div className="lg:col-span-3">
          <Col title="Contact">
            <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors"><Mail size={16} className="text-[var(--mint-light)]" />{BRAND.email}</a>
            <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} className="text-[var(--mint-light)]" />{BRAND.phone} <span className="text-slate-500">· Mobile</span></a>
            <a href="tel:+911147009571" data-testid="footer-landline" className="flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} className="text-[var(--mint-light)]" />{BRAND.landline}</a>
            <a href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-white transition-colors"><MessageCircle size={16} className="text-[var(--mint-light)]" />WhatsApp {BRAND.phone}</a>
            <div data-testid="footer-fax" className="flex items-center gap-3"><Printer size={16} className="text-[var(--mint-light)]" />Fax {BRAND.fax}</div>
            <Link to="/#contact" className="btn-pill btn-mint mt-4 !py-2.5 text-xs">Request a Quote <ArrowUpRight size={14} className="arrow" /></Link>
          </Col>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap gap-x-6 gap-y-2 border-t border-white/10 pt-8 font-mono text-[0.62rem] uppercase tracking-[0.2em] text-slate-500">
        {REGIONS.map((r) => <span key={r.code}>{r.name}</span>)}
      </div>
      <div className="mt-6 flex flex-col gap-2 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</span>
        <span>GVT · PGVT · Porcelain slabs · Made in India</span>
      </div>
    </div>
  </footer>
);
